import { Button, Form, Input, Slider } from "antd";
import { useEffect } from "react";
import { useBranding } from "./modules/useBranding";

const BrandingTemplate = () => {
  const {
    fetchBranding,
    branding,
    gradientStart,
    gradientEnd,
    handleInputChange,
    handleFileChange,
    handleSave,
    setGradientStart,
    setGradientEnd,
  } = useBranding();

  useEffect(() => {
    fetchBranding();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      <h1>Branding Settings</h1>
      <Form layout="vertical">
        <Form.Item label="Page Background Image">
          <input type="file" onChange={handleFileChange} accept="image/*" />
          <div style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
            Note: Maximum upload size: 2MB, format: JPG
          </div>
          {branding.pageBackgroundImage && (
            <img
              src={branding.pageBackgroundImage}
              alt="Background Preview"
              style={{ width: "100%", marginTop: "10px" }}
            />
          )}
        </Form.Item>
        <Form.Item label="Room Name Color">
          <Input
            type="color"
            name="roomNameColor"
            value={branding.roomNameColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Button Color">
          <Input
            type="color"
            name="buttonColor"
            value={branding.buttonColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Navbar Color">
          <Input
            type="color"
            name="navbarColor"
            value={branding.navbarColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Footer Color">
          <Input
            type="color"
            name="footerColor"
            value={branding.footerColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Star Rating Color">
          <Input
            type="color"
            name="starRatingColor"
            value={branding.starRatingColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Drag Bar Color">
          <Input
            type="color"
            name="dragBarColor"
            value={branding.dragBarColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Navbar Menu Color">
          <Input
            type="color"
            name="navbarMenuColor"
            value={branding.navbarMenuColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Search Bar Gradient - Start Color">
          <Input
            type="color"
            value={gradientStart.color}
            onChange={(e) =>
              setGradientStart((prev) => ({ ...prev, color: e.target.value }))
            }
          />
          <Slider
            min={0}
            max={1}
            step={0.01}
            value={gradientStart.opacity}
            onChange={(value) =>
              setGradientStart((prev) => ({ ...prev, opacity: value }))
            }
            tooltip={{
              formatter: (value) => `Opacity: ${Math.round(value * 100)}%`,
            }}
          />
        </Form.Item>

        <Form.Item label="Search Bar Gradient - End Color">
          <Input
            type="color"
            value={gradientEnd.color}
            onChange={(e) =>
              setGradientEnd((prev) => ({ ...prev, color: e.target.value }))
            }
          />
          <Slider
            min={0}
            max={1}
            step={0.01}
            value={gradientEnd.opacity}
            onChange={(value) =>
              setGradientEnd((prev) => ({ ...prev, opacity: value }))
            }
            tooltip={{
              formatter: (value) => `Opacity: ${Math.round(value * 100)}%`,
            }}
          />
        </Form.Item>

        {/* Gradient Preview */}
        <div
          className="searchbar-preview"
          style={{
            marginTop: "10px",
            height: "50px",
            borderRadius: "8px",
            background: branding.searchBarGradient,
          }}
        ></div>
        <Form.Item className="mt-3" label="Heading Color">
          <Input
            type="color"
            name="headingColor"
            value={branding.headingColor}
            onChange={handleInputChange}
          />
        </Form.Item>

        <Form.Item label="Heading Font">
          <select
            name="headingFont"
            value={branding.headingFont}
            onChange={handleInputChange}
            style={{ width: "100%", padding: "8px", borderRadius: 4 }}
          >
            <option value="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif">
              -apple-system / System UI
            </option>
            <option value="Roboto, 'Helvetica Neue', Arial, sans-serif">
              Roboto
            </option>
            <option value="Oxygen, 'Helvetica Neue', Arial, sans-serif">
              Oxygen
            </option>
            <option value="Impact, Charcoal, sans-serif">Impact</option>
            <option value="'Arial Narrow Bold', Arial, sans-serif">
              Arial Narrow Bold
            </option>
            <option value="Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', sans-serif">
              Ubuntu
            </option>
            <option value="Cantarell, 'Fira Sans', 'Droid Sans', sans-serif">
              Cantarell
            </option>
            <option value="'Fira Sans', 'Droid Sans', 'Helvetica Neue', Arial, sans-serif">
              Fira Sans
            </option>
            <option value="'Droid Sans', 'Helvetica Neue', Arial, sans-serif">
              Droid Sans
            </option>
            <option value="'Helvetica Neue', Arial, sans-serif">
              Helvetica Neue
            </option>
            <option value="'Bebas Neue', Arial, sans-serif">Bebas Neue</option>
            <option value="Verdana, Geneva, sans-serif">Verdana</option>
            <option value="sans-serif">sans-serif</option>
            <option value="Open Sans, 'Helvetica Neue', Arial, sans-serif">
              Open Sans
            </option>
            <option value="Lato, 'Helvetica Neue', Arial, sans-serif">
              Lato
            </option>
            <option value="Montserrat, 'Helvetica Neue', Arial, sans-serif">
              Montserrat
            </option>
            <option value="Oswald, Impact, sans-serif">Oswald</option>
            <option value="Source Sans 3, 'Helvetica Neue', Arial, sans-serif">
              Source Sans 3
            </option>
            <option value="Raleway, 'Helvetica Neue', Arial, sans-serif">
              Raleway
            </option>
            <option value="Merriweather, Georgia, serif">Merriweather</option>
            <option value="Noto Sans, 'Helvetica Neue', Arial, sans-serif">
              Noto Sans
            </option>
            <option value="Poppins, 'Helvetica Neue', Arial, sans-serif">
              Poppins
            </option>
            <option value="Lora, Georgia, serif">Lora</option>
            <option value="Inconsolata, 'Courier New', monospace">
              Inconsolata
            </option>
          </select>
        </Form.Item>

        {/* Font Preview */}
        <div style={{ marginTop: 12 }}>
          <div style={{ marginBottom: 6, fontWeight: 600 }}>Font Preview</div>
          <div
            style={{
              border: "1px solid #eaeaea",
              padding: 12,
              borderRadius: 6,
              fontFamily: branding.headingFont,
            }}
          >
            <div style={{ fontSize: 18 }}>
              The quick brown fox jumps over the lazy dog
            </div>
            <div style={{ fontSize: 14, color: "#666", marginTop: 6 }}>
              This is a sample paragraph using the selected font.
            </div>
          </div>
        </div>
        <Form.Item label="Paragraph Color">
          <Input
            type="color"
            name="paragraphColor"
            value={branding.paragraphColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Form.Item label="Paragraph Font">
          <select
            name="paragraphFont"
            value={branding.paragraphFont}
            onChange={handleInputChange}
            style={{ width: "100%", padding: "8px", borderRadius: 4 }}
          >
            <option value="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif">
              -apple-system / System UI
            </option>
            <option value="Roboto, 'Helvetica Neue', Arial, sans-serif">
              Roboto
            </option>
            <option value="Oxygen, 'Helvetica Neue', Arial, sans-serif">
              Oxygen
            </option>
            <option value="Impact, Charcoal, sans-serif">Impact</option>
            <option value="'Arial Narrow Bold', Arial, sans-serif">
              Arial Narrow Bold
            </option>
            <option value="Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', sans-serif">
              Ubuntu
            </option>
            <option value="Cantarell, 'Fira Sans', 'Droid Sans', sans-serif">
              Cantarell
            </option>
            <option value="'Fira Sans', 'Droid Sans', 'Helvetica Neue', Arial, sans-serif">
              Fira Sans
            </option>
            <option value="'Droid Sans', 'Helvetica Neue', Arial, sans-serif">
              Droid Sans
            </option>
            <option value="'Helvetica Neue', Arial, sans-serif">
              Helvetica Neue
            </option>
            <option value="'Bebas Neue', Arial, sans-serif">Bebas Neue</option>
            <option value="Verdana, Geneva, sans-serif">Verdana</option>
            <option value="sans-serif">sans-serif</option>
            <option value="Open Sans, 'Helvetica Neue', Arial, sans-serif">
              Open Sans
            </option>
            <option value="Lato, 'Helvetica Neue', Arial, sans-serif">
              Lato
            </option>
            <option value="Montserrat, 'Helvetica Neue', Arial, sans-serif">
              Montserrat
            </option>
            <option value="Oswald, Impact, sans-serif">Oswald</option>
            <option value="Source Sans 3, 'Helvetica Neue', Arial, sans-serif">
              Source Sans 3
            </option>
            <option value="Raleway, 'Helvetica Neue', Arial, sans-serif">
              Raleway
            </option>
            <option value="Merriweather, Georgia, serif">Merriweather</option>
            <option value="Noto Sans, 'Helvetica Neue', Arial, sans-serif">
              Noto Sans
            </option>
            <option value="Poppins, 'Helvetica Neue', Arial, sans-serif">
              Poppins
            </option>
            <option value="Lora, Georgia, serif">Lora</option>
            <option value="Inconsolata, 'Courier New', monospace">
              Inconsolata
            </option>
          </select>
        </Form.Item>
        <Form.Item label="Price Tag Color">
          <Input
            type="color"
            name="priceTagColor"
            value={branding.priceTagColor}
            onChange={handleInputChange}
          />
        </Form.Item>
        <Button className="mt-3" type="primary" onClick={handleSave}>
          Save
        </Button>
      </Form>
    </div>
  );
};

export default BrandingTemplate;
